import React from 'react'
import style from "./Property.module.css";

const Debt = ({index, key_name, handleInput, data}) => {

  return (
    <div className={style.add_txt}>
      <div className={style.item_input_text}>
        <p className={style.tit}>항목</p>
        <input type="text" name={`${key_name}_kind`} data-index={index} placeholder='기업은행 마이너스 통장' value={data?.kind} onChange={handleInput}/>
      </div>

      <div className={style.item_input_text}>
        <p className={style.tit}>상세 내용<span className={style.small}>(채무 액수, 사용처 등)</span></p>
        <div className={style.item_input_textarea}>
          <textarea name={`${key_name}_detail`} data-index={index} placeholder='마이너스 1억원, 생활비 명목' value={data?.detail} onChange={handleInput}/>
        </div>
      </div>

      <div className={style.item_input_text}>
        <p className={style.tit}>증거자료 유무</p>
        <input type="text" name={`${key_name}_evidence`} data-index={index} placeholder='대출계약서 있음' value={data?.evidence} onChange={handleInput}/>
      </div>
    </div>
  )
}

export default Debt